// extracted by mini-css-extract-plugin
export default {"root":"IconChevronToggle_root__8drwl","open":"IconChevronToggle_open__s+JzK"};